<template>
  <div class="flex flex-col h-full content-start space-y-5 grid gap-2">
    <div class="pb-2">
      <Icon @click="goBack" icon="ant-design:arrow-left-outlined" class="text-xl cursor-pointer" />
    </div>
    <div class="grid gap-2">
      <div class="flex space-x-1 items-center">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
          </template>
          <div class="w-40 whitespace-normal text-center">
             Select “Literature Reviews” and prompts to help write a review will appear.
          </div>
        </v-tooltip>
        <span class="font-semibold text-sm 2xl:text-base">Select the prompt category (i.e., type of instruction)</span>
      </div>

      <TlSelectSearch
        placeholder="Select a prompt category or type to search"
        v-model="selectedCategory"
        :items="promptTemplateCategoryData"
      />
    </div>

    <div v-if="selectedCategory" class="flex flex-col space-y-2 flex-1 w-full">
      <div class="flex space-x-1 items-center">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
          </template>
          <div class="w-40 whitespace-normal text-center">
            Select the prompt you want to use. Then, modify the text (e.g., [topic]). When you select a prompt, it will be automatically inserted into the chat.
          </div>
        </v-tooltip>
        <span class="font-semibold text-sm 2xl:text-base">Select the prompt (i.e., instruction)</span>
      </div>
      <div class="overflow-y-auto overflow-x-hidden h-screen">
        <div class="w-full flex-1 bg-white rounded-md shadow-lg">
          <div
            v-for="(option, index) in fetchPrompts(selectedCategory)"
            :key="index"
            @click="insertPrompt(option.prompt)"
            class="w-full hover:!bg-gray-200 py-3 px-4 break-words cursor-pointer duration-200"
          >
            <span class="">{{ option.prompt }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TlSelectSearch from '@/components/global/TlSelectSearch.vue';
import { Icon } from '@iconify/vue';
import { Vue, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { usePayloadStore } from '@/stores/payload';

@Options({
  components: {
    Icon,
    TlSelectSearch
  }
})
export default class AITextGeneratorPromptTemplates extends Vue {
  @Prop()
  public promptTemplateFeedbackData: any;

  @Prop()
  public promptTemplateCategoryData: any;

  public goBack() {
    this.$emit('closePromptTemplates');
  }

  mounted() {
    
  }


  private payloadStore = usePayloadStore();
  public loadingResponse = this.payloadStore.payload.loadingResponse;

  @Watch('payloadStore.payload.loadingResponse')
  public onLoadingResponse() {
    this.loadingResponse = this.payloadStore.payload.loadingResponse;
  }

  public selectedCategory: any = null;
  public selectedItem: string | null = null;
  @Watch('selectedCategory')
  public onSelectedCategory() {
    console.log(this.selectedCategory, 'bhhjbhbhhbb');
  }

  public onSelectedItemChange(val: any) {
    if (val === this.selectedItem) this.selectedItem = null;
    else this.selectedItem = val;
  }

  public fetchPrompts(val: any) {
    console.log('sddsdd')
    return this.promptTemplateFeedbackData?.find((p: any) => p.id === val)?.payload || []
  }

  public insertPrompt(prompt: string) {
    this.$emit('insertPrompt', prompt);
  }
}
</script>

<style>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>
